module.exports = __webpack_public_path__ + "files/16370421c6359fa25698b4e48069455b.png";